module.exports = __webpack_public_path__ + "img/online-bank-pay.e7203df6.svg";